<header class="lekkerland-header" [class.mobile-layout]="useMobileLayout()">
  <div #headerContent class="header-content">
    <button
      type="button"
      class="mobile-menu-button"
      aria-label="Navigation"
      (click)="openNavigation.emit()"
    >
      <ui-icon faName="bars" faStyle="light"></ui-icon>
    </button>

    @if (headerLogo(); as logo) {
      <a class="logo" uiLink link="/">
        <ui-image [data]="logo" objectFit="contain"></ui-image>
      </a>
    }

    <div #desktopNavigation class="desktop-navigation">
      <ui-lekkerland-desktop-navigation></ui-lekkerland-desktop-navigation>
    </div>

    <div class="language-navigation">
      @if (showLanguageSwitch()) {
        <ui-language-navigation [dropdown]="true" [menuTitle]="config().translations?.languageSwitchTitle"></ui-language-navigation>
      }
    </div>
  </div>
</header>
